const envConfigs = {
  // enviroment: "dev",
  enviroment: "live"
};

export default envConfigs;
